(function () {
  'use strict';

  var SELECTOR = '[data-rvrn-process-steps]';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initSection(section) {
    if (section.dataset.rvrnInit) return;
    section.dataset.rvrnInit = 'true';

    var autoplay = section.dataset.autoplay !== 'false';
    var speed = parseFloat(section.dataset.speed || '4', 10) * 1000;
    if (!speed || speed < 2000) speed = 4000;

    var nodes = Array.prototype.slice.call(section.querySelectorAll('[data-rvrn-node]'));
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-rvrn-card]'));

    if (!nodes.length || !cards.length) return;

    /* JS ready: enable reveal animations + nav dim states + slideshow mode */
    section.setAttribute('data-js-ready', '');

    /* ---- nav click: smooth scroll to card ---- */
    nodes.forEach(function (node) {
      node.addEventListener('click', function () {
        var target = document.getElementById(node.dataset.target);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* ---- scroll highlight (IntersectionObserver) ---- */
    function setActive(index) {
      nodes.forEach(function (n, i) {
        n.classList.toggle('is-active', i === index);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = cards.indexOf(entry.target);
          if (idx === -1) return;
          entry.target.classList.add('is-visible');
          setActive(idx);
        });
      }, { threshold: 0.2, rootMargin: '-10% 0px -30% 0px' });
      cards.forEach(function (card) { observer.observe(card); });
      /* first card active immediately */
      cards[0].classList.add('is-visible');
    } else {
      cards.forEach(function (card) { card.classList.add('is-visible'); });
    }

    /* ---- stage media slideshow ---- */
    var shows = Array.prototype.slice.call(section.querySelectorAll('[data-rvrn-slideshow]'));

    function initSlideshow(media) {
      var slides = Array.prototype.slice.call(media.querySelectorAll('[data-rvrn-slide]'));
      if (slides.length < 2) return;
      media.setAttribute('data-multi', '');
      var idx = 0;
      var timer = null;

      function show(i) {
        slides.forEach(function (s, si) { s.classList.toggle('is-active', si === i); });
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      function start() {
        stop();
        if (!autoplay || reduceMotion.matches) return;
        timer = setInterval(function () {
          idx = (idx + 1) % slides.length;
          show(idx);
        }, speed);
      }

      media.addEventListener('mouseenter', stop);
      media.addEventListener('mouseleave', start);
      media.addEventListener('focusin', stop);
      media.addEventListener('focusout', start);

      show(0);
      start();
    }

    shows.forEach(initSlideshow);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor: newly added sections */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector ? event.target.querySelector(SELECTOR) : null;
    if (section) initSection(section);
  });
})();
